var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      attrs: {
        "align-center": "",
        "justify-space-between": "",
        row: "",
        "fill-height": "",
        wrap: ""
      }
    },
    [
      _c(
        "v-flex",
        { attrs: { "px-2": "", md6: "", xs12: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "numeric",
                expression: "'numeric'"
              }
            ],
            attrs: {
              name: "rg",
              label: "Numero registro",
              "error-messages": _vm.errors.first("rg"),
              error: _vm.errors.has("rg")
            },
            on: {
              change: function($event) {
                return _vm.updateContent()
              }
            },
            model: {
              value: _vm.content.rg,
              callback: function($$v) {
                _vm.$set(_vm.content, "rg", $$v)
              },
              expression: "content.rg"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "px-2": "", md6: "", xs12: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|alpha_spaces",
                expression: "'required|alpha_spaces'"
              }
            ],
            attrs: {
              name: "rgIssuingAuthority",
              label: "Orgao emissor",
              "error-messages": _vm.errors.first("rgIssuingAuthority"),
              error: _vm.errors.has("rgIssuingAuthority")
            },
            on: {
              change: function($event) {
                return _vm.updateContent()
              }
            },
            model: {
              value: _vm.content.rgIssuingAuthority,
              callback: function($$v) {
                _vm.$set(_vm.content, "rgIssuingAuthority", $$v)
              },
              expression: "content.rgIssuingAuthority"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "px-2": "", md6: "", xs12: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|alpha_spaces",
                expression: "'required|alpha_spaces'"
              }
            ],
            attrs: {
              name: "issueState",
              label: "Estado emissor",
              "error-messages": _vm.errors.first("issueState"),
              error: _vm.errors.has("issueState")
            },
            on: {
              change: function($event) {
                return _vm.updateContent()
              }
            },
            model: {
              value: _vm.content.issueState,
              callback: function($$v) {
                _vm.$set(_vm.content, "issueState", $$v)
              },
              expression: "content.issueState"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "px-1": "", md6: "", xs12: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: "##/##/####",
                expression: "'##/##/####'"
              }
            ],
            attrs: {
              name: "issueDate",
              label: "Data de expedicao",
              "error-messages": _vm.errors.first("issueDate"),
              error: _vm.errors.has("rgIssuingDate")
            },
            on: {
              change: function($event) {
                return _vm.updateContent()
              }
            },
            model: {
              value: _vm.content.issueDate,
              callback: function($$v) {
                _vm.$set(_vm.content, "issueDate", $$v)
              },
              expression: "content.issueDate"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "px-1": "", md6: "", xs12: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: "###.###.###-##",
                expression: "'###.###.###-##'"
              }
            ],
            attrs: {
              name: "cpf",
              label: "CPF",
              "error-messages": _vm.errors.first("cpf"),
              error: _vm.errors.has("cpf")
            },
            on: {
              change: function($event) {
                return _vm.updateContent()
              }
            },
            model: {
              value: _vm.content.cpf,
              callback: function($$v) {
                _vm.$set(_vm.content, "cpf", $$v)
              },
              expression: "content.cpf"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "px-1": "", md6: "", xs12: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|alpha_spaces",
                expression: "'required|alpha_spaces'"
              }
            ],
            attrs: {
              name: "name",
              label: "Nome",
              "error-messages": _vm.errors.first("name"),
              error: _vm.errors.has("name")
            },
            on: {
              change: function($event) {
                return _vm.updateContent()
              }
            },
            model: {
              value: _vm.content.name,
              callback: function($$v) {
                _vm.$set(_vm.content, "name", $$v)
              },
              expression: "content.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-flex",
        { attrs: { "px-1": "", md6: "", xs12: "" } },
        [
          _c("v-text-field", {
            directives: [
              {
                name: "mask",
                rawName: "v-mask",
                value: "##/##/####",
                expression: "'##/##/####'"
              }
            ],
            attrs: {
              name: "birthDate",
              label: "Data de nascimento",
              "error-messages": _vm.errors.first("birthDate"),
              error: _vm.errors.has("birthDate")
            },
            on: {
              change: function($event) {
                return _vm.updateContent()
              }
            },
            model: {
              value: _vm.content.birthDate,
              callback: function($$v) {
                _vm.$set(_vm.content, "birthDate", $$v)
              },
              expression: "content.birthDate"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-75ecba88", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75ecba88","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/Documents/DocumentContent.vue
// module id = null
// module chunks = 